const MAX_TAIL = 32;

export function createTerminalQueryResponder() {
  let tail = "";

  function feed(output) {
    if (typeof output !== "string" || output.length === 0) return [];

    const combined = tail + output;
    const replies = [];

    for (let i = 0; i < combined.length; i++) {
      if (combined.charCodeAt(i) !== 0x1b || i + 1 >= combined.length) continue;
      if (combined.charCodeAt(i + 1) !== 0x5b) continue; // '['

      let j = i + 2;
      while (j < combined.length) {
        const ch = combined.charCodeAt(j);
        if (ch >= 0x40 && ch <= 0x7e) {
          break;
        }
        j += 1;
      }

      if (j >= combined.length) {
        break;
      }

      const params = combined.slice(i + 2, j);
      const finalChar = combined[j];

      if (finalChar === "c") {
        // DA / Secondary DA query
        if (params === "" || params === "0") {
          replies.push("\x1b[?1;2c");
        } else if (params === ">" || params === ">0") {
          replies.push("\x1b[>0;136;0c");
        }
      } else if (finalChar === "n") {
        // DSR 6n: cursor position report
        if (params === "6") {
          replies.push("\x1b[1;1R");
        }
      }

      i = j;
    }

    tail = combined.slice(-MAX_TAIL);
    return replies;
  }

  return { feed };
}
